<div class="auth-layout llayout">
    <dbp-login-header></dbp-login-header>

    <div class="llayout__body">
        <router-outlet class="shell"></router-outlet>
    </div>

    <dbp-login-footer></dbp-login-footer>
</div>